import { gql } from '@apollo/client';

export const GET_PROGRAMME_MONITORINGFORM = gql`
  query GetProgrammeMonitoringForm($input: GetProgrammeMonitoringFormInput!) {
    monitoringForm: getProgrammeMonitoringForm(input: $input) {
      id
      name
      description
      captureValue
      version
      published
      period {
        id
        name
      }
      programme {
        id
        name
      }
      intervention {
        id
        name
        programme {
          id
          name
        }
      }
      dueDates {
        id
        date
        periodNumber
      }
      reporters {
        id
        funder {
          id
          name
        }
        serviceProvider {
          id
          name
        }
        institution {
          id
          name
        }
      }
      users {
        id
        reporter {
          id
          funder {
            id
            name
          }
          serviceProvider {
            id
            name
          }
          institution {
            id
            name
          }
        }
        formRole {
          id
          name
        }
        user {
          id
          firstName
          lastName
          email
        }
      }
      indicators {
        id
        dimensions
        indicator {
          id
          indicatorLabel
          measurementUnit
          type
          unit
          variable
          name
          description
          resultRelationship
          minValueAllowed
          maxValueAllowed
          dimensions {
            id
            index
            name
          }
          periods {
            id
            periodDate
            periodNumber
            label
          }
        }
      }
      reporterSubmissions {
        id
        updatedAt
        status
        statusDate
        periodNumber
        reporter {
          id
          funder {
            id
            name
          }
          serviceProvider {
            id
            name
          }
          institution {
            id
            name
          }
        }
        respondent {
          id
          lastName
          firstName
          email
        }
      }
    }
  }
`;
